export default __webpack_public_path__ + "static/media/taxi-light.0c1d7d84.svg";